import { render, staticRenderFns } from "./TrashTag.vue?vue&type=template&id=347bfd4a&scoped=true"
import script from "./TrashTag.vue?vue&type=script&lang=js"
export * from "./TrashTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347bfd4a",
  null
  
)

export default component.exports